// config.js
import { OSS_URL } from "@/api/oss";
import {defaultMainConfig} from "./defaultConfig";

let config = null
let ruleConfig = null
let layerMapConfig = null
let fileConfig = null

let mainConfig = null

export async function getConfig() {
    if (config) {
        return config;
    }

    const configBucket = "config";
    const configKey = "config.json";
    const fileUrl = `${OSS_URL}/file/${configBucket}/${configKey}`;
    try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const tempConfig = await response.json();
        config = initConfig(tempConfig);
        console.log("get config remote ok", config);
    } catch (error) {
        console.error("Failed to fetch remote config, using default.", error);
        config = initConfig(defaultConfig, false)
    }
    return config;
}

export async function getRuleConfig() {
    if (ruleConfig) {
        return ruleConfig;
    }

    const configBucket = "config";
    const configKey = "rule_config.json";
    const fileUrl = `${OSS_URL}/file/${configBucket}/${configKey}`;
    try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const tempConfig = await response.json();
        ruleConfig = initRuleConfig(tempConfig);
        console.log("get rule config remote ok", ruleConfig);
    } catch (error) {
        console.error("Failed to fetch remote defaultRuleConfig, using defaultRuleConfig.", error);
        ruleConfig = initRuleConfig(defaultRuleConfig, false)
    }
    return ruleConfig;
}

function initRuleConfig(configData, remote=true) {
    const resConfig = {
        "keywordMapping": configData["keywordMapping"],
        "ruleMapping": configData["ruleMapping"]
    }
    return resConfig;
}


function initConfig(configData, remote=true) {
    const resConfig = {
        "checkList": configData,
        "remote": remote
    }
    const checkItemMap = {}
    const commonAndGerberItems = []
    const commonItems = []
    const otherGerberItems = []
    const gerberLayerMap = {}
    const gerberClassMap = {}

    for (let i=0; i < configData.length; i++) {

        const checkObj = configData[i]
        const objKey = checkObj["keyword"]
        checkItemMap[objKey] = checkObj

        if (checkObj['refer'].includes("common_file") || checkObj['layer'] === "common_file") {
            commonItems.push(checkObj)
        }

        if (checkObj['refer'].includes("gerber") &&  checkObj['layer'] === "common_file") {
            commonAndGerberItems.push(checkObj)
        }
        if (checkObj['refer'].includes("common_file") && checkObj['layer'] !== "common_file") {
            commonAndGerberItems.push(checkObj)
        }

        if (checkObj['refer'].length === 1 && checkObj['refer'][0] === "gerber" && checkObj['layer'] === "other") {
            otherGerberItems.push(checkObj)
        }

        const currentLayers = checkObj['layer'] in gerberLayerMap ? gerberLayerMap[checkObj['layer']] : []
        currentLayers.push(checkObj)
        gerberLayerMap[checkObj['layer']] = currentLayers

        const currentClasses = checkObj['check_list_classes'] in gerberClassMap ? gerberClassMap[checkObj['check_list_classes']] : []
        currentClasses.push(checkObj)
        gerberClassMap[checkObj['check_list_classes']] = currentClasses
    }

    resConfig['checkItemMap'] = checkItemMap
    resConfig['commonAndGerberItems'] = commonAndGerberItems
    resConfig['commonItems'] = commonItems
    resConfig['otherGerberItems'] = otherGerberItems
    console.log("resConfig['otherGerberItems']", resConfig['otherGerberItems'])

    resConfig['gerberLayerMap'] = gerberLayerMap
    resConfig['gerberClassMap'] = gerberClassMap

    return resConfig
}


export async function getLayerMapConfig() {
    if (layerMapConfig) {
        return layerMapConfig;
    }

    const configBucket = "config";
    const configKey = "layer_map_config.json";
    const fileUrl = `${OSS_URL}/file/${configBucket}/${configKey}`;
    try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const tempConfig = await response.json();
        layerMapConfig = initLayerMapConfig(tempConfig);
        console.log("get layerMapConfig config remote ok", layerMapConfig);
    } catch (error) {
        console.error("Failed to fetch remote defaultLayerMapConfig, using defaultLayerMapConfig.", error);
        layerMapConfig = initLayerMapConfig(defaultLayerMapConfig, false)
    }
    return layerMapConfig;
}

function initLayerMapConfig(configData, remote=true) {
    return configData;
}


export async function getFileConfig() {
    if (fileConfig) {
        return fileConfig;
    }

    const configBucket = "config";
    const configKey = "file_config.json";
    // todo
    const fileUrl = `${OSS_URL}/file/${configBucket}/${configKey}`;
    try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const tempConfig = await response.json();
        fileConfig = initFileConfig(tempConfig);
        console.log("get fileConfig config remote ok", fileConfig);
    } catch (error) {
        console.error("Failed to fetch remote defaultLayerMapConfig, using defaultLayerMapConfig.", error);
        fileConfig = initFileConfig(defaultFileConfig, false)
    }
    return fileConfig;
}

function initFileConfig(configData, remote=true) {
    return configData;
}



function initMainConfig(configData, remote=true) {
    return configData;
}

export async function getMainConfig() {
    if (mainConfig) {
        return mainConfig;
    }

    const configBucket = "config";
    const configKey = "main_config.json";
    // todo
    const mainUrl = `${OSS_URL}/file/${configBucket}/${configKey}`;
    try {
        const response = await fetch(mainUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const tempConfig = await response.json();
        mainConfig = initMainConfig(tempConfig);
        console.log("get mainConfig config remote ok", mainConfig);
    } catch (error) {
        console.error("Failed to fetch remote defaultLayerMapConfig, using defaultLayerMapConfig.", error);
        mainConfig = initMainConfig(defaultMainConfig, false)
    }
    const params = mainConfig.params
    const standard_config = mainConfig.standard_config
    const paramsMap = {}

    const kvParams = []
    const textParams = []
    const tableParams = []
    const checklist = []
    const checklistMap = {} // checklist 参数
    const checklistKeys = []  // checklist 顺序
    const checklistStandardMap = {}  // checklist配置，说明哪些必填
    const keyword2Label = {}

    standard_config.forEach(configItem => {
        checklistKeys.push(configItem.keyword)
        checklistStandardMap[configItem.keyword] = configItem
    })

    params.forEach((paramItem) => {
        const keyword = paramItem.keyword;
        paramsMap[keyword] = paramItem
        switch (paramItem.type) {
            case "int":
            case "range":
            case "str":
            case "enumeration":
                kvParams.push(paramItem)
                break
            case "text":
                textParams.push(paramItem)
                break
            case "table":
                tableParams.push(paramItem)
                break
            default:
                console.error("unexpect type", paramItem.type, paramItem)
        }

        const paramCopy = {...paramItem}
        checklist.push(paramCopy)
        checklistMap[keyword] = paramCopy
    })
    mainConfig['kvParams'] = kvParams
    mainConfig['textParams'] = textParams
    mainConfig['tableParams'] = tableParams
    mainConfig['checklist'] = checklist
    mainConfig['checklistMap'] = checklistMap
    mainConfig['checklistKeys'] = checklistKeys
    mainConfig['checklistStandardMap'] = checklistStandardMap
    mainConfig['keyword2Label'] = keyword2Label

    const labelToParamConfig = mainConfig.label_to_param_config
    for (let labelKey in labelToParamConfig) {
        const labelConfigItem = labelToParamConfig[labelKey]
        labelConfigItem['labelKvParams'] = []
        labelConfigItem['labelTextParams'] = []
        labelConfigItem['labelTableParams'] = []

        const labelContainParamKeys = labelConfigItem.params
        labelContainParamKeys.forEach(paramKey => {
            const paramItem = paramsMap[paramKey]
            if (!paramItem) {
                console.error("unexpect paramItem paramKey", paramKey)
                return
            }
            keyword2Label[paramKey] = labelKey
            paramItem['position'] = labelConfigItem['position']
            paramItem["parsed"] = false
            switch (paramItem.type) {
                case "int":
                case "range":
                case "str":
                case "enumeration":
                    labelConfigItem['labelKvParams'].push(paramItem)
                    break
                case "text":
                    labelConfigItem['labelTextParams'].push(paramItem)
                    break
                case "table":
                    labelConfigItem['labelTableParams'].push(paramItem)
                    break
                default:
                    console.error("unexpect type", paramItem.type, paramItem)
            }
        })
    }

    mainConfig['params_map'] = paramsMap
    checkMainConfig(mainConfig)
    return mainConfig;
}

function checkMainConfig(mainConfig) {
    const checklist = mainConfig['checklist']
    const checklistMap = mainConfig['checklistMap']
    const checklistKeys = mainConfig['checklistKeys']
    const checklistStandardMap = mainConfig['checklistStandardMap']
    console.log("checklistKeys", checklistKeys)
    checklistKeys.forEach(key => {
        if (!checklistStandardMap[key]) {
            console.error("unexpect checklistStandardMap", key)
        }
    })

}

export async function getThirdConfig() {
    const configBucket = "config";
    const configKey = "third_config.json";

    const mainUrl = `${OSS_URL}/file/${configBucket}/${configKey}`;
    try {
        const response = await fetch(mainUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const thirdConfig = await response.json();

        console.log("get thirdConfig config remote ok", thirdConfig);
        return thirdConfig;
    } catch (error) {
        console.error("Failed to fetch remote getThirdConfig", error);
    }
}
